export const objectionClassificationScheme: Record<string, string> = {
    amcu: "Порушення, пов'язані з вимогами законодавства",
    amcu_24: "Порушення, пов'язані з процедурою 24 годин",
    article_16: "Кваліфікаційні критерії процедури закупівлі",
    article_17: "Підстави для відмови в участі у процедурі закупівлі",
    other: "Інші вимоги процедури закупівлі",
    violation_amcu: "Процедурні порушення у процедурі закупівлі",
};
